module.exports = __webpack_public_path__ + "img/lxwm.82dad79d.png";